import { request } from '../../helpers/api/request';

export const deleteCategory = async (id: number) => {
    const { data } = await request({
        url: `admin/categories/${id}`,
        method: 'DELETE',
    });

    return data;
};
